import React from 'react';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { BonoItem } from './BonoItem';
import { bonos, kitExtras } from '../data/bonos';
export function BonosSection() {
  return <section className="bg-mp-dark py-16 md:py-24" data-id="element-41" data-mp="13cmktsealrk1">
      <Container data-id="element-42" data-mp="yeumafj5776v">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-43" data-mp="yfcl9jx6vzih">
          <p className="font-heading text-base uppercase leading-snug text-mp-white sm:text-lg" data-id="element-44" data-mp="yd08dl6agfca">
            Los 5 tomos te dan el sistema.
          </p>
          <p className="mt-1 font-heading text-lg uppercase leading-snug text-mp-lime sm:text-xl" data-id="element-45" data-mp="oflpzg0t1ghc">
            Los Bonos de Implementación te ayudan a llevarlo a la práctica.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-[700px] text-center" data-id="element-46" data-mp="fha57ummdcwt">
          <SectionTag tone="lime" data-id="element-47" data-mp="2est1p9qqkspl">Bonos de implementación</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl" data-id="element-48" data-mp="2er02ugmd7cs5">
            El kit que te ayuda a aplicarlo en pista.
          </h2>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-49" data-mp="qu39hjdsuccf">
          {bonos.map((bono, index) => <BonoItem key={bono.number} bono={bono} index={index} data-id="element-50" data-mp="hupz8ohupjqn" data-mpi={index} />)}
        </div>

        <p className="mx-auto mt-10 max-w-[500px] text-center text-xs uppercase tracking-[0.15em] text-mp-gray" data-id="element-51" data-mp="mtt3w7tx5ny3">
          Incluidos solo en Maestro en Pista + Kit de Ejecución
        </p>
        <div className="mx-auto mt-4 grid max-w-[700px] grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-52" data-mp="1alrh4xcxhtdv">
          {kitExtras.map((bono, index) => <BonoItem key={bono.number} bono={bono} index={index} data-id="element-53" data-mp="10u3t76fkyuh5" data-mpi={index} />)}
        </div>
      </Container>
    </section>;
}